export const lg_page401 = {
  page401_th: {
    title: "401",
    title_details: "คุณไม่ได้รับสิทธิ์ในการเข้าถึงหน้านี้",
    title_details2: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
    btn: "กลับสู่หน้าหลัก",
     btn_login: "เข้าสู่ระบบ",
  },
  page401_en: {
    title: "401",
    title_details: "Access Denied",
    title_details2: "You don’t have permission to access this page.",
     btn: "Back to Home",
       btn_login: "Login",
  },
};

